import { Component } from '@angular/core';
import { CustomerReportingCsvService } from '@app/customer-reporting/services/customer-reporting-csv.service';
import { ReportTableColumn } from '@app/customer-reporting/models/report-table-column.model';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { ViewDidEnter, ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { catchError, filter, of, Subscription } from 'rxjs';
import { ProductUsageTable } from '@app/customer-reporting/constants/product-usage-table-config';
import { CustomerReportingToastService } from '@app/customer-reporting/services/customer-reporting-toast.service';

@Component({
  selector: 'app-product-usage',
  templateUrl: './product-usage.page.html',
  styleUrls: ['./product-usage.page.scss'],
})
export class ProductUsagePageComponent
  implements ViewWillEnter, ViewDidEnter, ViewWillLeave
{
  isMobile = false;
  dataSource = [];
  noData = false;
  dataLoaded = false;

  tableDataSubscription: Subscription;
  columnsToDisplay: ReportTableColumn[] = ProductUsageTable;

  constructor(
    public platformService: PlatformService,
    readonly panAppState: PanAppState,
    private customerReportingCsvService: CustomerReportingCsvService,
    private toastService: CustomerReportingToastService,
  ) {}

  ionViewWillEnter() {
    this.panAppState.setPageTitle('Product Usage');
    this.isMobile =
      this.platformService?.platformType ===
      this.platformService?.platformEnum?.mobile;
  }

  ionViewDidEnter() {
    this.getCsvAsJson();
  }

  ionViewWillLeave(): void {
    this.dataLoaded = false;
    this.noData = false;
    this.dataSource = [];
    this.toastService.clearToasts();

    if (this.tableDataSubscription) {
      this.tableDataSubscription.unsubscribe();
    }
  }

  getCsvAsJson() {
    this.tableDataSubscription = this.customerReportingCsvService
      .getCsvAsJson()
      .pipe(
        filter(data => !!data),
        catchError(err => {
          return of(err);
        }),
      )
      .subscribe(data => {
        if (data.status === 400) {
          this.noData = true;
          this.dataLoaded = true;

          this.toastService.show(
            'Product Usage',
            'apierror',
            0,
            true,
            data.status,
          );
        } else {
          this.dataSource = data.rows.slice(0, 10);

          if (this.dataSource.length === 0) {
            this.noData = true;
          }

          this.dataLoaded = true;
        }
      });
  }
}
